<template>
	<div>
	
	<topbar></topbar>

<div class="clear"></div>
<div class="header">
	<div class="header line">
		<div class="w1200 bc">
			<a class="logo fl" :href="indexUrl" title="云永云商城"></a>
			<div class="search">
				<span class="ico"></span>
				<input class="text" type="text" v-model="sortParam" placeholder="请输入关键字">
				<button class="btn" @click="findGoods()">搜商品</button>
				<button class="btn" @click="findShops()" style="margin-left: 3px;">搜店铺</button>
			</div>
			<div class="r-box fr" style="display: none;">
				<div class="mycart" @mouseenter="shopCarShow()" @mouseleave="shopCarHide()">
					<i class="ico-cart"></i>
					<a href="#">我的购物车</a>
					<span class="ico-shopping-amount">{{ shoppingCartNum }}</span>
					<i class="ico-r"></i>
					<div class="goods-list none" style="display: none;">
						<div class="spacer"></div>
						<!--没选商品-->
						<div v-if="shoppingCartNum == 0" class="no-goods">
							<img src="../../../static/images/settleup-nogoods.png" width="57" height="49">购物车中还没有商品，赶紧选购吧！
						</div>
						<!--已选商品-->
						<div v-if="shoppingCartNum > 0" class="mylist">
							<h4>最新加入的商品</h4>
							<ul>
								<!--<li class="li-1"><span class="fr">小计：￥599.00</span></li>-->
								<li class="li-2" v-for="bo in boList" v-bind:id="bo.goodsCode+'_cart_pro'" >
									<a class="fl spic" href="#"><img v-bind:src="bo.imgSmall" width="50" height="50"></a>
									<p class="name">
										<a href="#">{{ bo.goodsName }}</a> &nbsp;&nbsp;&nbsp;<span>数量：{{ bo.goodsNumber }}</span>
									</p>
									<p class="other"><span>￥{{ bo.goodsPrice }}</span><br>
										<a class="del"  v-on:click="deleteGoods(bo.goodsCode)">删除</a>
									</p>
								</li>
							</ul>
							<div class="fbar"><span class="fl ml10">共{{ count }}件商品　共计<b>￥ {{ sumMoney }}</b></span>
								<a class="fr gobuy" href="#">去购物车</a>
							</div>
						</div>
					</div>
				</div>
				<div v-if="isLogin==true" class="myorder ml25" @mouseenter="orderShow()" @mouseleave="orderHide()">
							<i class="ico-orders"></i>
							<a @click="goOrder('')">我的订单 <span class="ico-shopping-amount">{{ allCount }}</span></a></a>
							<i class="ico-r"></i>
							<div class="orders-list orders">
                		<ul>
                    		<li><a href="javascript:void(0)" @click="goOrder('wait_buyer_pay')">等待买家付款 <span class="ico-shopping-amount" style="text-align: center;">{{ payCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('wait_send_goods')">等待卖家发货 <span class="ico-shopping-amount" style="text-align: center;">{{ sendCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('wait_buyer_confirm_goods')">等待确认收货 <span class="ico-shopping-amount" style="text-align: center;">{{ putCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('trade_finish')">订单完成 <span class="ico-shopping-amount" style="text-align: center;">{{ receiveCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('trade_close')">订单关闭 <span class="ico-shopping-amount" style="text-align: center;">{{ closeCount }}</span></a></li>
                    	</ul>
                		</div>
						</div>
			</div>
		</div>
	</div>
</div>

<div class="head-nav clear-l">
	<div class="w1200 bc">
        <!--商城分类-->
    	<div class="mall-categorys fl">
        	<div class="hd" v-on:mouseenter="goodsCateShow()"><a href="#">全部分类</a></div>
            <div class="sc-submenu none" style="opacity: 0.85;background: rgb(130, 122, 123);" v-on:mouseleave="goodsCateHidden()">
            	<ul>
                	<li class="li-1" v-for="cat in catList" v-on:mouseleave="childCateHide(cat.catCode)">
                    	<div class="yj" v-on:mouseenter="childCateShow(cat.catCode)" style="background: rgb(130, 122, 123);">
                        	<i class="sc-ico-nav sc-ico-01"></i>
                            <a class="fb" style="color: #fdfbfb;">{{cat.catNameCn}}</a>
                            <i class="sc-ico-arrow"></i>
                        </div>
                        <div class="sc-submenu-all none" v-on:mouseenter="childCateShow(cat.catCode)" v-bind:id="cat.catCode+'_child'">
                            <dl>
                            	<dt><i></i>{{cat.catNameCn}}</dt>
                                <dd>
                                	<a @click="getCatGoods(childCat.catCode,childCat.catNameCn)" v-for="childCat in cat.catBoList">{{childCat.catNameCn}}</a>
                                    <a @click="getMoreCatGoods(cat.catCode,cat.catNameCn)">更多</a>
                                </dd>
                            </dl>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!--导航-->
        <ul class="nav fl">
            <li>
                <a @click="goIndex()">商城首页</a>
            </li>
            <li v-for="(carBo, index) in catList" v-if="index<6">
                <a @click="getMoreCatGoods(carBo.catCode,carBo.catNameCn)">{{carBo.catNameCn}}</a>
            </li>
        </ul>
    </div>
</div>
<!--顶部：导航 结束-->

<div class="clear mt15"></div>
<!--container 开始-->
<div class="w1200 bc">
	<!--位置 开始-->
    <div class="hq-crumb-wrap">
    	<ul>
        	<li class="item">首页</li>
            <li class="item sep">></li>
            <li class="item">{{sortParam}}</li>
        </ul>
    </div>
    <!--位置 结束-->
    
  <!-- 右侧商品 开始-->
  <div class="sp-side-wrap">
    	<div class="hd">
            <h3>相关店铺</h3>
        </div>
        <ul>
            <li v-for="relativeShop in relativeShopList">
                <a class="fl pic" @click="goShop(relativeShop.shopCode)"><img v-bind:src="relativeShop.shopStandarLogo" width="106" height="106"></a>
                <p class="title">
                    <a @click="goShop(relativeShop.shopCode)">{{relativeShop.shopName}}</a>
                </p>
            </li>
        </ul>
    </div>
    <!-- 右侧商品 结束-->
    
    <!-- 商品搜索 开始-->
    <div class="sp-search-list">
  <div class="l-hd">
        	<div class="top-num fr">共{{totalItem}}条 <span class="co2">{{sortParam}}</span></div>
        	<h3>搜索结果</h3>
        </div>
        
        <div class="pro-list">
        	<ul>
            	<li v-for="shopBo in shopList">
                	<p class="img"><a @click="goShop(shopBo.shopCode)"><img v-bind:src="shopBo.shopStandarLogo" width="265" height="265"></a></p>
                    <p class="title"><i class="ico-shop-l"></i><a @click="goShop(shopBo.shopCode)">{{shopBo.shopName}}</a></p>
                </li>
            </ul>
        </div>
        <div class="dp-pages tc">
            <a @click="prePage()"> < </a>
            <a v-bind:class='{"current_page":currentPage === page}' v-for="page in pageList" @click="queryByPage(page)">{{page}}</a>
            <a @click="nextPage()"> > </a>
        </div>
  </div>
    <!-- 商品搜索 结束-->
    <div class="clear"></div>
    <div class="mb20 ad-4 mt20"><img src="../../../static/images/footer-ad-1.png" width="1200" height="60"></div>
</div>
<!--container 结束-->
<div class="clear"></div>
<footermenu></footermenu>
		<footercopyright></footercopyright>
	</div>
</template>

<script>
	//import {jQuery} from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import API from "../../../static/api/api.js"
	import {getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,getIndexUrl} from "../../../static/js/emallUtils.js"
	import dbmain from '../../../static/js/db-main.js'
	import TopBar from '@/components/TopBar'
	import Header from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import FooterCopyright from '@/components/FooterCopyright'
	export default {
		name: 'shopsList',
		components: {
			'topbar':TopBar,
			'sortHeader':Header,
			'footermenu':FooterMenu,
			'footercopyright':FooterCopyright
		},
		data(){
            return {
            	goodsList:[],
            	recommendGoodsList:[],
            	sortCondition:'defaultSort',
			    sortSaleAmount:'',
			    sortPublishTime:'',
			    sortPrice:'',
			    choosedCondItem:[],
		     	catCode:'categoryAll',
		     	interval:'intervalAll',
		     	sortTime:'timeAll',
		     	currentPage:1,
		     	totalPage:1,
		     	orderBy:'',
		     	orderAsc:'',
		     	shopCode:'',
		     	pageList:[1],
		     	totalItem:0,
		     	sortParam:'',
		     	shoppingCartNum:0,
				boList:[],
				count:0,
				goodsImgs:[],
				sumMoney:0,
				goodsName:'',
				firstCatCode:'',
				catList:[],
				isLogin:false,
				mobile:'',
			    isShow:false,
			    account:'',
			    shopList:[],
			    relativeShopList:[],
			    indexUrl:'',
				allCount:0,
				payCount:0,
				putCount:0,
				receiveCount:0,
				sendCount:0,
				closeCount:0
            }
        },
        methods:{
        	orderShow:function(){
				jQuery(".orders-list").show();
			},
			orderHide:function(){
				jQuery(".orders-list").hide();
			},
			shopCarShow:function(){
				jQuery(".goods-list").show();
			},
			shopCarHide:function(){
				jQuery(".goods-list").hide();
			},
        	getOrderCount:function(shopCode){
        		var that=this;
        		API.getOrderCount(function(ret){
        			if(ret.code == "success"){
        				that.allCount = ret.data.allCount;
        				that.payCount = ret.data.payCount;
        				that.putCount = ret.data.putCount;
        				that.receiveCount = ret.data.receiveCount;
        				that.sendCount = ret.data.sendCount;
        				that.closeCount = ret.data.closeCount;
        			}
        		})
        	},
        	goOrder:function(tradeStatus){
				var account = localStorage.getItem("account");
				if(account != undefined && account != ""){
					window.location.href=this.orderUrl+"?tradeStatus="+tradeStatus;
				}else{
					window.location.href=getUcUrl()+'/login.htm';
				}
			},
        	 mobileAppShow:function(){
		  		this.isShow = true;
		  	 },
		  	 mobileAppHidden:function(){
		  		this.isShow = false;
		  	 },
        	jumpTo:function(name){
		  		this.$router.push({ name:name});
		  	},
        	toGoodsDetail:function(goodsCode){
				this.$router.push({ name: 'goodsdetail', params:{goodsCode:goodsCode}});
		  	},
		  	prePage:function(){
		  		if(this.currentPage > 1){
		  			 this.currentPage = this.currentPage -1;
		  			 this.getShopList();
		  		}
		  	},
		  	nextPage:function(){
		  		if(this.currentPage < this.totalPage){
		  			this.currentPage = this.currentPage +1;
		  			this.getShopList();
		  		}
		  	},
		  	queryByPage:function(page){
		  			this.currentPage = page;
		  			this.getShopList();
		  	},
		  	findGoods:function(){
		  			this.$router.push({ name: 'goodsList', query:{sortParam:this.sortParam}});
		  	},
		  	findShops:function(){
		  			this.getRelativeShopList();
					this.getShopList();
		  	},
		  	goodsCateShow:function(){
					$(".categorys-dropdown").show();
			 },
			 goodsCateHidden:function(){
					$(".categorys-dropdown").hide();
			 },
			 goShop:function(shopCode){
		  	 	this.$router.push({name:'shop_index',query:{shopCode:shopCode}});
		  	 },
		     getRelativeShopList:function(){
			 	var that = this;
			 	var shopType = "";
			 	var shopName = encodeURI(that.sortParam);
			 	var currentPage = 1;
			 	var pageSize = 6;
			 	API.getShopList(shopName,currentPage,shopType,pageSize,function(ret){
			 		if(ret.code == "success"){
			 			var shopList = ret.data.shopList;
			 			if(shopList != undefined){
			 				for(var i=0;i<shopList.length;i++){
			 					var shopStandarLogo = shopList[i].shopStandarLogo;
			 					 shopStandarLogo = getImgUrl()+"/upload/show.htm?filePath="+shopStandarLogo;
			 					 shopList[i].shopStandarLogo = shopStandarLogo;
			 				}
			 				that.relativeShopList = shopList;
			 			}
			 		}
			 	});
			 },
			 getShopList:function(){
			 	var that = this;
			 	var shopType = "";
			 	var shopName = encodeURI(that.sortParam);
			 	var currentPage = that.currentPage;
			 	var pageSize = 9;
			 	API.getShopList(shopName,currentPage,shopType,pageSize,function(ret){
			 		if(ret.code == "success"){
			 			var shopList = ret.data.shopList;
			 			if(shopList != undefined){
			 				for(var i=0;i<shopList.length;i++){
			 					var shopStandarLogo = shopList[i].shopStandarLogo;
			 					 shopStandarLogo = getImgUrl()+"/upload/show.htm?filePath="+shopStandarLogo;
			 					 shopList[i].shopStandarLogo = shopStandarLogo;
			 				}
			 				that.shopList = shopList;
			 			}
			 			that.totalItem = ret.data.totalItem;
						var totalPage = ret.data.totalPage;
						var pageList = new Array();
						if(totalPage != undefined && totalPage != 0){
				         	 for(var i=1;i<=totalPage;i++){
				         	 		pageList.push(i);
				         	 }
				         	 that.totalPage = totalPage;
						}else{
							pageList.push(1);
						}
						that.pageList = pageList;
			 		}
			 	});
			 },
			getShoppingCartNum:function(shopCode){
        		var that=this;
        		API.getShoppingCartNum(function(ret){
        			if(ret.code == "success"){
        				that.shoppingCartNum = ret.data.shoppingCartNum;
        			}
        		});
        	},
        	getShoppingCartList:function(){
        		var that=this;
        		API.getShoppingCartList(function(ret){
					 if(ret.code == "success"){
					 	that.boList = ret.data.boList;
					 	var totalCount = 0;
					 	var bos = new Array();
					 	bos = ret.data.boList;
					 	var money = 0;
					 	for(var i =0; i<bos.length;i++){
					 		var imgSmall = bos[i].imgSmall;
		                    if(imgSmall.indexOf(";")!=-1){
		                    	imgSmall=imgSmall.split(";")[0];
		                    }					 		
					 		bos[i].imgSmall = getImgUrl()+"/upload/show.htm?filePath="+imgSmall;
					 		money = money + bos[i].goodsPrice * bos[i].goodsNumber;
					 		totalCount = totalCount + bos[i].goodsNumber;
					 	}
					 	that.sumMoney = money;
					 	that.count = totalCount;
					 	
					 }
        		})
        	},
        	deleteGoods:function(goodsCode){
        		var that=this;
        		API.deleteGoods(goodsCode, function(ret){
        			if(parseResult(ret, null, false)) {
						jQuery("#" + goodsCode + "_cart_pro").remove();
						
					}
        		})
        	},
        	goIndex:function(){
		  		this.$router.push({name:'index'});
		  	},
        	getMoreCatGoods:function(catCode,catNameCn){
        		this.$router.push({name:'goodsList',query:{firstCatCode:catCode,catNameCn:catNameCn}});
		  	},
		  	getCatGoods:function(catCode,catNameCn){
		  	 	this.$router.push({name:'goodsList',query:{catCode:catCode,catNameCn:catNameCn}});
		  	},
			goodsCateShow:function(){
				jQuery(".sc-submenu").show();
			},
			goodsCateHidden:function(){
				jQuery(".sc-submenu").hide();
			},
			childCateShow:function(catCode){
				jQuery("#"+catCode+"_child").show();		
			},
			childCateHide:function(catCode){
				jQuery("#"+catCode+"_child").hide();		
			},
		 	getCat:function(){
        		var that = this;
        		API.getAllCat('',function(ret){
        			if(ret.code == "success"){
        				that.catList = ret.data.firstCatList;
        			}
        		});
        	},
        	resetCond:function(){
        		this.interval = "intervalAll";
        		this.catCode = "categoryAll";
        		this.sortTime = "timeAll";
        		this.firstCatCode = "";
        		this.orderBy = "";
        		this.orderAsc = "";
        		jQuery("#choosedCond").html("");
        	}
        },
        ready:function(){
        	
		},
		mounted(){
			window.scrollTo(0, 0);
			var account = localStorage.getItem("account");
			if(account != undefined && account != ""){
				this.isLogin = true;
				this.account = account;
			}
			var sortParam = this.$route.query.sortParam;
			var firstCatCode = this.$route.query.firstCatCode;
			var catCode = this.$route.query.catCode;
			if(sortParam != undefined){
				this.sortParam = sortParam;
			}
			if(firstCatCode != undefined){
				this.firstCatCode = firstCatCode;
			}
			if(catCode != undefined){
				this.catCode = catCode;
			}
			this.indexUrl = getIndexUrl();
			this.getCat();
			this.getRelativeShopList();
			this.getShopList();
			this.getShoppingCartNum();
			this.getShoppingCartList();
			this.getOrderCount();
		}
	}
</script>

<style scoped>
.current_page{
	border: solid 1px #ea524e;
}
.demensional_code{
	height: 100px;
    width: 100px;
    z-index: 99;
    background-color: gainsboro;
    position: absolute;
    right: 45px;
}
</style>


// WEBPACK FOOTER //
// src/page/shop/shopsList.vue?c32e8198